import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0247d002"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "myReports",
  class: "section-light-gray text-big"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-default-back back-button",
  onclick: "window.history.back()"
}, "Back", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin-bottom":"20px"} }, "My Reports", -1))

import MyReportsTable from "../../components/my-reports/my-reports-table.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'my-reports',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(MyReportsTable)
    ])
  ]))
}
}

})